import { render, staticRenderFns } from "./ChangeGroupStatus.vue?vue&type=template&id=6bd96a92&scoped=true"
import script from "./ChangeGroupStatus.vue?vue&type=script&lang=ts"
export * from "./ChangeGroupStatus.vue?vue&type=script&lang=ts"
import style0 from "./ChangeGroupStatus.vue?vue&type=style&index=0&id=6bd96a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd96a92",
  null
  
)

export default component.exports